
$(function () {

    var div_show = $('#showMe'),
        arrow = $('#arrow');
    div_show.css('display', 'none');
    arrow.css('display', 'none');


    var enablelo = "Y";
    if (enablelo == "Y") {
        var vCode = ' @ViewData["COOKAGENT"]';
        if (vCode == " " || vCode == null || vCode == "") {
            div_show.css('display', 'none');
            arrow.css('display', 'none');

        } else {

            var a = getCookie("lostate");
            if (a == " " || a == null || a == "") {
                setCookie("lostate", "open", 1);
                a = getCookie("lostate");
                arrow.css('display', 'none');
                div_show.css('display', 'block');
            } else {

                if (a == "open") {
                    arrow.css('display', 'none');
                    div_show.css('display', 'block');
                }
                if (a == "close") {
                    div_show.css('display', 'none');
                    arrow.css('display', 'block');
                }
            }

        }
    }
    else {
        div_show.css('display', 'none');
        arrow.css('display', 'none');
    }
    $('.expandContent').click(function () {
       setCookie("lostate", "open", 1);
        div_show.slideToggle('fast', function () {
            arrow.css('display', 'none');
        });
    });

    $('.bcClose').click(function () {
        setCookie("lostate", "close", 1);
        div_show.slideToggle('fast', function () {
            arrow.css('display', 'block');
        });
    }
    );

  


    function setCookie(cname, cvalue, exdays) {
        var d = new Date();
        d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
        var expires = "expires=" + d.toUTCString();
        document.cookie = cname + "=" + cvalue + ";path=/";
    }

    function getCookie(cname) {
        var name = cname + "=";
        var ca = document.cookie.split(';');
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
                return c.substring(name.length, c.length);
            }
        }
        return "";
    }

});



